import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
import _imports_0 from '@/assets/mapv2/bgyunl.png';
import _imports_1 from '@/assets/mapv2/bgyunr.png';
const _hoisted_1 = {
  class: "bg"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  id: "bdmap",
  class: "bdmap",
  ref: "bdmap"
};
const _hoisted_7 = {
  key: 0,
  class: "routeDialog"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  key: 3,
  class: "yunbox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapv2assembly = _resolveComponent("mapv2assembly");
  const _component_typev2 = _resolveComponent("typev2");
  const _component_mappopupv2 = _resolveComponent("mappopupv2");
  const _component_pointlistv2 = _resolveComponent("pointlistv2");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_routelist = _resolveComponent("routelist");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mapContainer", {
      'isMobile': $props.isMobile
    }]),
    style: _normalizeStyle($data.mainStyle)
  }, [_createElementVNode("div", {
    class: _normalizeClass([`formUserId${$data.formUserId}`]),
    style: {
      "width": "100%",
      "height": "100%",
      "position": "relative"
    }
  }, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.mapelem.bg
  }, null, 8, _hoisted_2)], 512), [[_vShow, $data.mapelem.bg !== '']]), _withDirectives(_createElementVNode("div", {
    class: "logo",
    style: _normalizeStyle($data.modulestyle.logo)
  }, [_createElementVNode("img", {
    src: $data.mapelem.logo
  }, null, 8, _hoisted_3)], 4), [[_vShow, $data.mapelem.logo !== '']]), _withDirectives(_createElementVNode("div", {
    class: "pickey",
    style: _normalizeStyle($data.modulestyle.pickey)
  }, [_createElementVNode("img", {
    src: $data.mapelem.pickey
  }, null, 8, _hoisted_4)], 4), [[_vShow, $data.mapelem.pickey !== '']]), $data.loadingmap ? (_openBlock(), _createBlock(_component_mapv2assembly, {
    key: 0,
    ref: "mapv2assembly",
    id: $props.id,
    showgdtilelayer: $data.mapLayers.tiles,
    showgeojsonlayer: $data.mapLayers.json,
    showstaticlayer: $data.mapLayers.static,
    showroutelayer: $data.mapLayers.route,
    staticimage: $data.mapLayers.staticimage,
    drawelement: $data.mapLayers.drawelement,
    geojson: $data.mapLayers.geojson,
    mapstyle: $data.mapstyle,
    adcode: $data.mapview.adcode,
    zoom: $data.mapview.zoom,
    minZoom: $data.mapview.minZoom,
    maxZoom: $data.mapview.maxZoom,
    extent: $data.mapview.extent,
    center: $data.mapview.center,
    scale: $data.mapview.scale,
    rotate: $data.mapview.rotate,
    translate: $data.mapview.translate,
    rotation: $data.mapview.rotation,
    streetcode: $data.mapstreetcode,
    pointlist: $data.pointList,
    culturallist: $data.mapculturalList,
    isMobile: $data.isMobileflag,
    onSingleclick: $options.singleclick,
    onMarkerclick: $options.markerclick,
    onMarkermoveend: $options.markermoveend
  }, null, 8, ["id", "showgdtilelayer", "showgeojsonlayer", "showstaticlayer", "showroutelayer", "staticimage", "drawelement", "geojson", "mapstyle", "adcode", "zoom", "minZoom", "maxZoom", "extent", "center", "scale", "rotate", "translate", "rotation", "streetcode", "pointlist", "culturallist", "isMobile", "onSingleclick", "onMarkerclick", "onMarkermoveend"])) : _createCommentVNode("", true), _createVNode(_component_typev2, {
    ref: "typev2",
    modeltype: $data.modeltype,
    typeshowflag: $data.form.showtype,
    typelist: $data.typeList,
    typebtnstyle: $data.typebtn,
    posstyle: $data.modulestyle.type,
    showtypeall: $data.mapstyle.typeall,
    typeallname: $data.mapstyle.typeallname,
    onTypeselect: $options.typeselect
  }, null, 8, ["modeltype", "typeshowflag", "typelist", "typebtnstyle", "posstyle", "showtypeall", "typeallname", "onTypeselect"]), _createVNode(_component_mappopupv2, {
    detail: $data.pointdetail,
    popshowflag: $data.popshowflag,
    modeltype: $data.popmodeltype,
    isMobile: $data.isMobileflag,
    direction: $data.switchScreenFlag,
    id: $props.id,
    onCloseHandle: $options.closeHandle
  }, null, 8, ["detail", "popshowflag", "modeltype", "isMobile", "direction", "id", "onCloseHandle"]), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["golist", `fid${$data.query.fid}`]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.golist && $options.golist(...args))
  }, [_createElementVNode("img", {
    src: $data.mapelem.golist,
    alt: ""
  }, null, 8, _hoisted_5)], 2), [[_vShow, $data.showgolist]]), $data.cTemplateScore === 1 ? (_openBlock(), _createBlock(_component_pointlistv2, {
    key: 1,
    ref: "pointlist",
    listshowflag: $data.form.showlist,
    formoption: $data.cformoption,
    datalist: $data.mapculturalList,
    modeltype: $props.style.listStyleIndex,
    style: _normalizeStyle($data.modulestyle.list),
    isMobile: $data.isMobileflag,
    onListclick: $options.pointlistClick,
    onListup: $options.listUp
  }, null, 8, ["listshowflag", "formoption", "datalist", "modeltype", "style", "isMobile", "onListclick", "onListup"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, null, 512), _createVNode(_component_el_dialog, {
    modelValue: $data.routePop,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.routePop = $event),
    title: "路线详情",
    width: $data.isMobileflag ? '80%' : '40%'
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[1] || (_cache[1] = $event => $data.routePop = false)
    }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })]),
    default: _withCtx(() => [_ctx.routeDetail ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("h3", null, _toDisplayString(_ctx.routeDetail.itemformdata.title), 1), _createElementVNode("div", {
      class: "introduce",
      innerHTML: _ctx.routeDetail.itemformdata.introduce
    }, null, 8, _hoisted_8)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "width"]), _createVNode(_component_routelist, {
    ref: "routelist",
    typelist: $data.rtypeList,
    routelist: $data.maprouteList,
    pointlist: $data.pointList,
    style: _normalizeStyle($data.mapstyle),
    isMobile: $data.isMobileflag,
    id: $props.id,
    onRoute: $options.routeChange
  }, null, 8, ["typelist", "routelist", "pointlist", "style", "isMobile", "id", "onRoute"]), $data.mapsenior.visit ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "visitWrap",
    style: _normalizeStyle($data.modulestyle.visit)
  }, [_withDirectives(_createElementVNode("span", null, _toDisplayString($data.mapsenior.visitname), 513), [[_vShow, $data.mapsenior.visitname !== '']]), _createElementVNode("span", null, _toDisplayString($data.visitItem[0].num), 1)], 4)) : _createCommentVNode("", true), $data.mapsenior.effect ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[4] || (_cache[4] = [_createElementVNode("img", {
    class: "yunl",
    src: _imports_0,
    alt: ""
  }, null, -1), _createElementVNode("img", {
    class: "yunr",
    src: _imports_1,
    alt: ""
  }, null, -1)]))])) : _createCommentVNode("", true)], 2)], 6);
}